import * as styles from "./PermissionManage.module.scss";
import React from "react";
interface NoAvailablePermissionProps {
  type: string;
}

function NoAvailablePermission({ type }: NoAvailablePermissionProps) {
  const scssClass = styles as any;
  return (
    <div className={scssClass.container}>
      <img
        src={"/assets/noRecords.svg"}
        alt="no records"
        width={80}
        height={74.67}
      />
      <span className={scssClass.title}>No {type}</span>
    </div>
  );
}

export default NoAvailablePermission;
